import React from 'react';

export const TITLE_ABOUT = [
  {
    textSize: '3.375rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>ACERCA DE</span>,
  },
];

export const ABOUT_NAME = [
  {
    textSize: '4rem',
    fontWeight: '600',
    marginBottom: '0px',
    lineHeight: '60px',
    textType: 'h2',
    textMobile: '2.125rem',
    renderContent: () => <span>JONATHAN BOUZALI</span>,
  },
];

export const ABOUT_CHARGE = [
  {
    textSize: '2.25rem',
    fontWeight: '900',
    lineHeight: '60px',
    marginBottom: '1.5rem',
    renderContent: () => (
      <span>
        <em>PRODUCTOR</em>
      </span>
    ),
  },
];

export const ABOUT_DESCRIPTION = [
  {
    textSize: '1.25rem',
    fontWeight: '400',
    marginBottom: '0px',
    lineHeight: '25px',
    textMobile: '0.875rem',
    renderContent: () => (
      <span>
        Jonathan Bouzali es un productor con más de dos décadas de experiencia
        en cine, televisión y publicidad, especializado en operar proyectos
        complejos para plataformas y estudios globales. Ha liderado producciones
        para Netflix, Paramount, Disney, Gaumont y Apple TV+, consolidando una
        trayectoria marcada por precisión operativa y control creativo. Entre
        sus créditos destacan títulos como Souvenir, el thriller periodístico
        Tijuana y diversos proyectos que abarcan drama, suspense, terror y
        comedia, demostrando una versatilidad narrativa poco común en la
        industria.
        <br />
        <br />
        Es miembro del programa PUENTES 2024 de EAVE, red internacional dedicada
        al desarrollo de coproducciones entre Europa y Latinoamérica.
        Paralelamente, cuenta con experiencia en la industria musical como
        miembro fundador y votante de los Latin Grammy (LARAS), lo cual amplía
        su entendimiento del ecosistema creativo más allá del medio audiovisual.
        <br />
        <br />
        Jonathan ha forjado alianzas estratégicas de alto nivel en producciones
        internacionales como 37 KMS y The Bachelor Japan (Amazon Studios),
        posicionando a su compañía —KUTER— dentro del circuito de productoras
        con capacidad real de entregar historias universales, culturalmente
        relevantes y técnicamente impecables.
        <br />
        <br />
        Todo el trabajo realizado en su calidad de productor durante estos años
        forma parte de su experiencia profesional y ha sido desarrollado ya sea
        de manera independiente o a través de las distintas etapas de
        consolidación de su propia casa productora.
        <br />
        <br />
        Hoy, Jonathan Bouzali concentra su actividad creativa y operativa
        únicamente bajo el sello KUTER Films, desde donde continúa impulsando,
        desarrollando y presentando los proyectos que encabeza.
      </span>
    ),
  },
];
